/**
 * Shared constants and pure helpers for the employee org chart.
 *
 * Node geometry lives here because both the layout pass and the SVG connector
 * pass need the exact same numbers — deriving them twice is how connectors end
 * up a few pixels off the cards they are supposed to join.
 */

export const NODE_WIDTH = 208;
export const NODE_HEIGHT = 84;
export const H_GAP = 28; // horizontal gap between sibling cards
export const V_GAP = 56; // vertical gap between levels (the elbow lives here)

export const COLUMN = NODE_WIDTH + H_GAP;
export const ROW = NODE_HEIGHT + V_GAP;

export const MIN_ZOOM = 0.2;
export const MAX_ZOOM = 2;

/** The synthetic node that gathers every real root into one canvas. */
export const COMPANY_ROOT_ID = '__company__';

export const COMPANY_ROOT = {
  id: COMPANY_ROOT_ID,
  name: 'Pebsteel Buildings',
  full_name: 'Pebsteel Buildings',
  title: null,
  isCompanyRoot: true,
};

/**
 * Depth at which the chart starts collapsed. 0 = company root, 1 = the BODs,
 * 2 = their direct reports — deep enough to show the shape of the company,
 * shallow enough that 670 people do not land on screen at once.
 */
export const DEFAULT_OPEN_DEPTH = 2;

/**
 * Vietnamese names are stored both with and without diacritics across this app
 * (`name` is a code like "LDQ", `full_name` is "Lê Đăng Quân"), and people type
 * either. Normalising both sides makes "le dang quan" find "Lê Đăng Quân".
 */
export const deaccent = (value) =>
  (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();

/** Ids from a node up to (and including) the company root. */
export const ancestorIdsOf = (nodeId, parentById) => {
  const path = [];
  let current = parentById.get(nodeId);
  const guard = new Set([nodeId]);

  while (current !== undefined && current !== null && !guard.has(current)) {
    path.push(current);
    guard.add(current);
    current = parentById.get(current);
  }

  return path;
};

export const employeeDetailPath = (id) => `/organization/employees/${id}`;
